// DuelLogic.js
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase'; // if not already

export function shuffleArray(array) {
  const copy = [...array];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}


export function loadDeckFromStorage() {
  const savedDecks = JSON.parse(localStorage.getItem('savedDecks'));
  const selectedDeckIndex = JSON.parse(localStorage.getItem('selectedDeckIndex'));


  if (savedDecks && selectedDeckIndex !== null && savedDecks[selectedDeckIndex]) {
    const deck = savedDecks[selectedDeckIndex];
    const shuffled = [...deck.main].sort(() => Math.random() - 0.5);
    return {
      main: shuffled.slice(5),
      extra: deck.extra || [],
      side: deck.side || [],
      hand: shuffled.slice(0, 5),
    };
  }

  return null;
}

export const handleDeckAction = ({
  action,
  mainDeck,
  setMainDeck,
  setHand,
  setMyGYZ,
  hand,
  setMyBZ,
  extraDeck,
  myGYZ,
  myBZ,
  roomId,
  playerRole,
  fieldMap
}) => {
  if (mainDeck.length === 0) return;

  const topCard = mainDeck[0];
  const rest = mainDeck.slice(1);

  switch (action) {
    case 'View':
      console.log('Deck:', mainDeck);
      break;

    case 'Banish FD': {
      const updatedMain = rest;
      const updatedBZ = [...myBZ, { ...topCard, isFaceDown: true }];

      setMainDeck(updatedMain);
      setMyBZ(updatedBZ);

      syncGameState({
        fieldMap,
        hand,
        mainDeck: updatedMain,
        extraDeck,
        gy: myGYZ,
        bz: updatedBZ,
        roomId,
        playerRole
      });
      break;
    }

    case 'Banish T.': {
      const updatedMain = rest;
      const updatedBZ = [...myBZ, topCard];

      setMainDeck(updatedMain);
      setMyBZ(updatedBZ);

      syncGameState({
        fieldMap,
        hand,
        mainDeck: updatedMain,
        extraDeck,
        gy: myGYZ,
        bz: updatedBZ,
        roomId,
        playerRole
      });
      break;
    }

    case 'Mill': {
      const updatedMain = rest;
      const updatedGY = [...myGYZ, topCard];

      setMainDeck(updatedMain);
      setMyGYZ(updatedGY);

      syncGameState({
        fieldMap,
        hand,
        mainDeck: updatedMain,
        extraDeck,
        gy: updatedGY,
        bz: myBZ,
        roomId,
        playerRole
      });
      break;
    }

    case 'Shuffle': {
      const shuffled = shuffleArray(mainDeck);
      setMainDeck(shuffled);

      syncGameState({
        fieldMap,
        hand,
        mainDeck: shuffled,
        extraDeck,
        gy: myGYZ,
        bz: myBZ,
        roomId,
        playerRole
      });
      break;
    }

    case 'Draw': {
      const updatedHand = [...hand, topCard];
      const updatedMain = rest;

      setHand(updatedHand);
      setMainDeck(updatedMain);

      syncGameState({
        fieldMap,
        hand: updatedHand,
        mainDeck: updatedMain,
        extraDeck,
        gy: myGYZ,
        bz: myBZ,
        roomId,
        playerRole
      });
      break;
    }

    default:
      break;
  }
};


export const syncGameState = async ({

  fieldMap,
  hand,
  mainDeck,
  extraDeck,
  gy,
  bz,
  roomId,
  playerRole
}) => {
  if (!roomId || !playerRole) return;
  if (!db) {
    console.error('🔥 Firestore DB is undefined!');
    return;
  }


  const roomRef = doc(db, 'duelRooms', roomId);

  try {
    await updateDoc(roomRef, {
      [`gameState.${playerRole}.fieldMap`]: fieldMap,
      [`gameState.${playerRole}.hand`]: hand,
      [`gameState.${playerRole}.mainDeck`]: mainDeck,
      [`gameState.${playerRole}.extraDeck`]: extraDeck,
      [`gameState.${playerRole}.gy`]: gy,
      [`gameState.${playerRole}.bz`]: bz,
      'gameState.updatedAt': serverTimestamp()
    });
    console.log('✅ syncGameState success');
  } catch (err) {
    console.error('🔥 syncGameState failed:', err);
  }
};

